import { SITE_URL } from "@api/constants/resources";
import { categoryPathMap } from "@/utils/breadcrumb/categories";

export const generateBreadcrumbItems = (
  pageType,
  data,
  pathSegments,
  canonicalUrl,
  id
) => {
  const breadcrumbItems = [];
  let currentPosition = 1;

  const lastSegment = pathSegments[pathSegments.length - 1];
  const isPagination = !isNaN(parseInt(lastSegment)) && isFinite(lastSegment);

  const cleanPathSegments = isPagination
    ? pathSegments.slice(0, -1)
    : pathSegments;

  // 홈 항목 추가
  breadcrumbItems.push({
    "@type": "ListItem",
    position: currentPosition++,
    name: data.parent || "홈",
    item: SITE_URL,
  });

  // 2차 카테고리 (sub) 추가
  if (data.sub) {
    let subPath = "";

    if (categoryPathMap[data.sub]) {
      // 이미 매핑된 카테고리가 있는 경우 해당 경로 사용
      subPath = categoryPathMap[data.sub];
    } else if (pathSegments[0] === "products") {
      subPath = "products";
    } else {
      subPath = pathSegments[0] || "";
    }

    breadcrumbItems.push({
      "@type": "ListItem",
      position: currentPosition++,
      name: data.sub,
      item: `${SITE_URL}/${subPath}/`,
    });
  }

  // 페이지 타입별 브레드크럼 생성 로직
  if (pageType === "cs") {
    // 고객센터 페이지 상세
    if (data.subTitle) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subTitle,
        item: `${SITE_URL}/${categoryPathMap[data.sub]}/${id}/`,
      });
    }
  } else if (pageType === "esg") {
    // ESG 페이지 브레드크럼 생성
    if (data.subTitle && data.subTitle !== data.sub) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subTitle,
        item: `${SITE_URL}/${categoryPathMap[data.subTitle] || "esg-guide/"}`,
      });
    }

    // 상세 페이지인 경우
    if (
      cleanPathSegments.length > 2 &&
      data.subChild &&
      data.subChild !== data.subTitle &&
      data.subChild !== data.sub
    ) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subChild,
        item: `${SITE_URL}/${
          categoryPathMap[data.subTitle] || "esg-guide/"
        }/${id}/`,
      });
    }
  } else if (pageType === "product") {
    // 상품 페이지 브레드크럼 생성
    const productPath = isPagination ? cleanPathSegments : pathSegments;

    // 3단계: 2차 카테고리
    if (productPath.length > 1) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subTitle,
        item: `${SITE_URL}/products/${productPath[1]}/`,
      });
    }

    // 4단계: 상품 2차 카테고리 상세 이름 - only if not pagination
    if (data.subChild && !isPagination) {
      const encodedSubChild = encodeURIComponent(data.subChild);

      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subChild,
        item: `${SITE_URL}/products/${productPath[1]}/${encodedSubChild}/`,
      });
    }

    // 5단계: 상품 상세 이름 - only if not pagination
    if (data.detailsubChild && !isPagination) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.detailsubChild,
        item: canonicalUrl,
      });
    }
  } else {
    // 일반 페이지 처리
    if (data.subTitle) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subTitle,
        item: `${SITE_URL}/${cleanPathSegments.slice(0, -1).join("/")}/`,
      });
    }

    if (data.subChild) {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: currentPosition++,
        name: data.subChild,
        item: canonicalUrl,
      });
    }
  }

  return breadcrumbItems;
};
